import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  ActionConfiguration,
  FormLayoutConfiguration,
  selectOptions
} from 'framework/lib/dynamic-form/field-configuration.interface';
import { EsamparkServiceService } from '../services/esampark-service.service';
import { COLORS } from 'src/styles/color-variable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidateForm } from 'framework';

import { Urls } from 'src/environments/urls';
import { ShareablESampark } from './n-bres';
import { CommonSharingService } from '../services/common-sharing.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-e-sampark',
  templateUrl: './e-sampark.component.html',
  styleUrls: ['./e-sampark.component.scss']
})
export class ESamparkComponent implements OnInit {
  esamarks: any[] = [];
  selectedItemMType: string | undefined;
  marketingByProfileObj: any;
  base64data: any = {

    campaignNo: null,
    content: null,
    videoFileExt: null,
    videoFileLink: null
  };
  requestObjToGetDoc: any = {
    nameCustomerAgent: '',
    publicUrl: '',
    profileDetailsObject: {
      profileName: '',
      emailId: '',
      mobileNumber: ''
    }
  };
  @ViewChild('esamparkDialog') esamparkDialog!: TemplateRef<any>;
  eSamparkConfig!: FormLayoutConfiguration[];
  eSamparkActionConfig!: ActionConfiguration[];
  eSamparkFG!: FormGroup;
   pipe = new DatePipe('en-US');
    requestObjLogs:any;
  sharableObj: ShareablESampark = {
    attachment: {
      contentType: 'base64',
      mimeType: '',
      fileName: '',
      fileExtension: ''
    },
    subject: '',
    body: '',
    emailId: '',
    mobileNo: ''
  };
  urlConfig: any;
  searchStr!: string;
  displayNoDtLabel: boolean = false;
  dialogMediaType!: string;
  emSampakToken: any;
  tokenpassed: any;
  constructor(
    private _dialog: MatDialog,
    private _esampark: EsamparkServiceService,
    private _commonSharing: CommonSharingService,
    private spinner: NgxSpinnerService,
    private _activateRoute:ActivatedRoute
  
  ) { this.gerFormData();}

  ngOnInit(): void {

   this.emSampakToken=this._activateRoute.snapshot.queryParamMap.get('tokenId');
    
   //this.emSampakToken=this._activateRoute.snapshot.params['tokenId'];
  
    this.getMediaList();
    this.getSharableCustomers();

    
  }


  gerFormData() {
    this.eSamparkConfig = [
      {
        fxLayout: 'column',
        fxLayoutAlign: 'space-between',
        display: 'stretch',
        align: 'column',
        lgGap: '1em',
        smGap: '0em',
        fields: [
          {
            componentType: 'autocomplete',
            name: 'customerName',
            value: null,
            label: 'Select Customer',
            // selectAttributes: {
            //   options: []
            // },
            autocompleteAttributes: {
              options: []
            },
            appearance: 'outline',
            hidden: true,
            validations: [
              {
                customValidation: false,
                name: 'required',
                validator: ['required'],
                message: 'Please Select Customer Name'
              }
            ],
            styleAttributes: {
              fontSize: '14px',
              width: '100%',
              color: '#2683d4',
              marginTop: '1em'
            },
            onClick: {
              funcName: 'getcustomerSeleted'
            }
          },
          {
            componentType: 'input',
            name: 'searchMedia',
            placeholder: 'Search',
            value: '',
            label: 'Search',
            appearance: 'outline',
            hidden: false,
            styleAttributes: {
              fontSize: '14px',
              width: '100%',
              color: COLORS.pictonBlue
            },
            onKeyup: {
              funcName: 'getSearchMedia'
            },
            onKeydown: {
              funcName: 'getSearchMedia'
            },
            inputAttributes: {
              inputType: 'text'
            }
          }
        ]
      }
    ];

    this.eSamparkActionConfig = [
      {
        funcName: 'getcustomerSeleted',
        funcDef: (customer: any) => {
          this.dropDownValChange(customer);
        }
      },
      {
        funcName: 'getSearchMedia',
        funcDef: (str: string) => {
          this.searchStr = str;
        }
      }
    ];
  }

  dropDownValChange(customer: any) {
    this.requestObjToGetDoc.nameCustomerAgent = this._commonSharing.toTitleCase(
      customer.value
    );
  }

  getSharableCustomers() {
    this.spinner.show('loader');
    this._esampark.getSharableCustomerData(this.emSampakToken).subscribe(
      (data) => {
        this.marketingByProfileObj = Object.assign(
          {},
          data.profileDetailsObject
        );
        this.requestObjToGetDoc.profileDetailsObject =
          data.profileDetailsObject;
        const customers: selectOptions[] = [];
      //  this.spinner.hide('loader');
        data.customerAgentNameList.forEach((ele:any) => {
          customers.push({
            key: ele.name,
            value: this._commonSharing.toTitleCase(ele.name.replace(/\./g, ''))
          });
        });
       // this.eSamparkConfig[0].fields[0].selectAttributes.options = customers;
       this.eSamparkConfig![0].fields![0].autocompleteAttributes!.options = customers;
        this.sharableObj.emailId = data.profileDetailsObject
          ? data.profileDetailsObject.emailId
          : '';
        this.sharableObj.mobileNo = data.profileDetailsObject
          ? data.profileDetailsObject.mobileNumber
          : '';
        this.spinner.hide('loader');
      },
      (error) => {
        this.spinner.hide('loader');
      }
    );
    // this.spinner.hide('loader');
  }

  getMediaList() {
    this.spinner.show('loader');
    this._esampark.getMediaData(this.emSampakToken).subscribe(
      (data) => {
        this.esamarks = data;
       
        this.requestObjLogs ={
          empCode:this.emSampakToken,
          empName:Urls.userFirstName,
          rmEmpCode: '',
          designation: Urls.RoleType,
          accessDate: this.pipe.transform(
            new Date(),
            'dd-MMM-yy hh:mm:ss'
          ),
          accessResource: 'ESAMPARK_WEB_SALES',
          event:'ESAMPARK',
          transactionStatus:'SUCCESS'
      }
      
      this._esampark
      .esmparkLogs(this.requestObjLogs)
      .subscribe(
        (data: any) => {        
        })
     
      },

      (error) => {
        this.displayNoDtLabel = true;
        this.spinner.hide('loader');
      }

    );
    this.spinner.hide('loader');
  }

  shareForCustomer(listItem: any, mediaType: string) {
    this.selectedItemMType = listItem.type;
    this.dialogMediaType=mediaType;
    this.setShareableObj(listItem);    
    if (listItem.type.toLowerCase() == 'image' || listItem.type.toLowerCase() == 'video' || listItem.type.toLowerCase() == 'pdf') {
      this.eSamparkConfig.forEach((rem:any) => {
        rem.fields.find((item:any) => item.name === 'customerName').hidden = false;
        rem.fields.find((item:any) => item.name === 'searchMedia').hidden = true;
      });
      this._dialog.open(this.esamparkDialog, {
        panelClass: 'custom-dialog',
        disableClose: true
      });
    } else this.finallyShare(listItem.type, listItem, mediaType);
  }

  closeShareModal() {
    this._dialog.closeAll();
    this.showSearchHideSelect();
  }

  showSearchHideSelect() {
    this.eSamparkConfig.forEach((rem:any) => {
      rem.fields.find((item:any) => item.name === 'customerName').hidden = true;
      rem.fields.find((item:any) => item.name === 'searchMedia').hidden = false;
    });
  }

  setShareableObj(rowObj: any) {
    this.requestObjToGetDoc.publicUrl = rowObj.publicUrl;
    this.base64data.campaignNo = rowObj.campaignNo;
    this.sharableObj.body = `Happy to share marketing collateral with you. Regards, ${Urls.userFirstName} ${Urls.userLastName}, M: ${this.sharableObj.mobileNo}, E: ${this.sharableObj.emailId}` //rowObj.shortDescription;
    //this.sharableObj.subject = rowObj.title;
    this.sharableObj.subject = `Happy to share marketing collateral with you. Regards, ${Urls.userFirstName} ${Urls.userLastName}, M: ${this.sharableObj.mobileNo}, E: ${this.sharableObj.emailId}`
    this.sharableObj.attachment.fileName = rowObj.campaignName
      ? rowObj.campaignName
      : 'fileName';
    this.calculateMimeType(rowObj.type, rowObj.publicUrl);
  }

  geteSamparkGroup(eve:any) {
    this.eSamparkFG = eve;
  }

  getDynamicImage(isFromModal: boolean, mediaType?:string) {
    let custName = null;
    if (isFromModal) {
      custName = this.eSamparkFG.value.customerName;
      this.requestObjToGetDoc.nameCustomerAgent = this.eSamparkFG
        ? this.eSamparkFG.value.customerName
        : '';
      if (this.requestObjToGetDoc.profileDetailsObject) {
        this.requestObjToGetDoc.profileDetailsObject.profileName =
          this._commonSharing.toTitleCase(
            this.marketingByProfileObj.profileName
              ? this.marketingByProfileObj.profileName
              : ''
          );
        this.requestObjToGetDoc.profileDetailsObject.emailId =
          this.marketingByProfileObj.emailId;
        this.requestObjToGetDoc.profileDetailsObject.mobileNumber =
          this.marketingByProfileObj.mobileNumber;
      }
    } else {
      this.requestObjToGetDoc.nameCustomerAgent = '';
      // not making empty info
      // this.requestObjToGetDoc.profileDetailsObject.profileName = '';
      // this.requestObjToGetDoc.profileDetailsObject.emailId = '';
      // this.requestObjToGetDoc.profileDetailsObject.mobileNumber = '';
    }
    if(mediaType=='videoOrPdf'){
      this._dialog.closeAll();
      this.spinner.show('loader');
      this.finallyShare(mediaType);
      this.showSearchHideSelect();
      this.spinner.hide('loader');
    }
    if ((custName && mediaType=='onlyImage') || !isFromModal) {
      this._dialog.closeAll();
      this.spinner.show('loader');
       console.log('-------------------');
       console.log(this.requestObjToGetDoc);
       console.log('------------------');
      this._esampark
        .shareSelectedDocToGetB64(this.requestObjToGetDoc)
        .subscribe(
          (data: any) => {
            this.base64data.content = data.base64Content;
            //     console.log('dynamicImg dialogAndroidObject/sharableObj =');
            // console.log(this.sharableObj);
            // console.log('dynamicImg base64data =');
            // console.log(this.base64data);
            // console.log('dynamicImg eSamparkFG');
            // console.log(this.eSamparkFG);
            // console.log('dynamicImg img/pdf file base64');
            // console.log(this.base64data.content);
            if(this.eSamparkFG.value.customerName){
              this.sharableObj.body = `Dear ${this.eSamparkFG.value.customerName}, Happy to share marketing collateral with you. Regards, ${Urls.userFirstName} ${Urls.userLastName}, M: ${this.sharableObj.mobileNo}, E: ${this.sharableObj.emailId}` //rowObj.shortDescription;
              this.sharableObj.subject = `Dear ${this.eSamparkFG.value.customerName}, Happy to share marketing collateral with you. Regards, ${Urls.userFirstName} ${Urls.userLastName}, M: ${this.sharableObj.mobileNo}, E: ${this.sharableObj.emailId}` //rowObj.shortDescription;
            }
            if (data.base64Content) {
              // const encodedUrl = encodeURIComponent(this.base64data.content);
              const dialogAndroidObject = btoa(
                JSON.stringify(this.sharableObj)
              );
              setTimeout(() => {
                // window.open(
                //   `http://share-content/${dialogAndroidObject}​​​​​​​​​​​​​​​​​?content=${encodedUrl}​​​​​​​​​​​​​​​​​`,
                //   '_blank'
                // );
                console.log(dialogAndroidObject);
                console.log(this.base64data.content);
                window.open(
                  `http://share-content/${dialogAndroidObject}?content=${this.base64data.content}`,
                  '_blank'
                );
              }, 100);
            } else {
              this._commonSharing.openSnackbar(
                null,
                'error',
                'Image base64 not received. please try again.'
              );
            }
            this.showSearchHideSelect();
            this.spinner.hide('loader');
          },
          (error) => {
            this._commonSharing.openSnackbar(error, 'error');
            this.showSearchHideSelect();
            this.spinner.hide('loader');
          }
        );
    } else {
      ValidateForm(this.eSamparkFG);
    }
  }

  calculateMimeType(type: string, fileName: string) {
    if (fileName && type) {
      let splitedArr = fileName.split('.');
      let fnameExt = splitedArr[splitedArr.length - 1];
      if (type == 'pdf') {
        this.sharableObj.attachment.contentType = 'base64';
        this.sharableObj.attachment.mimeType = 'application/pdf';
        this.base64data.videoFileExt = `eSampark-pdf.${fnameExt}`;
        this.sharableObj.attachment.contentType = 'http';
        this.base64data.videoFileLink = fileName;
      } else if (type.toLowerCase() == 'image') {
        this.sharableObj.attachment.contentType = 'base64';
        this.sharableObj.attachment.mimeType = `image/${fnameExt}`;
        this.sharableObj.attachment.fileExtension = `.${fnameExt}`;
      } else {
        this.sharableObj.attachment.mimeType = `video/${fnameExt}`;
        this.sharableObj.attachment.fileExtension = `.${fnameExt}`;
        this.sharableObj.attachment.contentType = 'http';
        this.base64data.videoFileExt = `eSampark-video.${fnameExt}`;
        this.base64data.videoFileLink = fileName;
      }
    }
  }

  finallyShare(mediaFormat: string, rowObj?: any, mediaType?:string) {
    
    // console.log('rowObj =');
    // console.log(rowObj);
    // console.log('dialogAndroidObject/sharableObj =');
    // console.log(this.sharableObj);
    // console.log('base64data =');
    // console.log(this.base64data);
    // console.log('eSamparkFG');
    // console.log(this.eSamparkFG);
    // console.log('img/pdf file base64');
    // console.log(this.base64data.content);
    if (rowObj != null) {
      this.eSamparkFG.value.customerName='';
      //this is important while direct sharing by social media
      this.setShareableObj(rowObj);
      if (rowObj.type.toLowerCase() == 'image') {
        this.selectedItemMType = rowObj.type;
        this.getDynamicImage(false,mediaType);
      }
    }
    const dialogAndroidObject = btoa(JSON.stringify(this.sharableObj));
    // console.log('this.base64data.videoFileLink');
    // console.log(this.base64data.videoFileLink);
    if(this.eSamparkFG.value.customerName){
      this.sharableObj.body = `Dear ${this.eSamparkFG.value.customerName}, Happy to share marketing collateral with you. Regards, ${Urls.userFirstName} ${Urls.userLastName}, M: ${this.sharableObj.mobileNo}, E: ${this.sharableObj.emailId}` //rowObj.shortDescription;
      this.sharableObj.subject = `Dear ${this.eSamparkFG.value.customerName}, Happy to share marketing collateral with you. Regards, ${Urls.userFirstName} ${Urls.userLastName}, M: ${this.sharableObj.mobileNo}, E: ${this.sharableObj.emailId}` //rowObj.shortDescription;
    }
    if (mediaFormat.toLowerCase() != 'image' && this.base64data.videoFileLink) {
      
        if (this.base64data.videoFileExt && this.base64data.videoFileLink) {
        // console.log(
        //   'this.base64data.videoFileLink',
        //   this.base64data.videoFileLink
        // );
        setTimeout(() => {
          window.open(
            `http://share-content/${dialogAndroidObject}?content=${this.base64data.videoFileLink}`,
            '_blank'
          );
        }, 100);
      } else {
        this._commonSharing.openSnackbar(
          null,
          'error',
          'video link not available'
        );
      }
    }
  }



}
